import { format, subDays } from "date-fns";
// import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { RadioButton } from "primereact/radiobutton";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import storage from "../../../Services/Storage";
import Axios from "../../../api/Axios";
import { MultiSelect } from "primereact/multiselect";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import {
    createAPIEndpointSalesReports,
    EndpointSalesReports,
} from "../../../Services/ReportsAll/SalesReportService";
import { toast } from "react-toastify";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
const TaxDetails = () => {
    const docno = [
        { name: "All", key: "ALL" },
        { name: "Invoice", key: "INV" },
    ];
    const typeWise = [
        { name: "Taxtypewise", key: "TAX" },
        { name: "Documentwise", key: "DOC" },
    ];
    let today = new Date();
    let tdt = subDays(today, 7);
    const [selectedDocno, setSelectedDocNo] = useState(docno[0]);
    const [selectedtypeWise, setSelectedTypeWise] = useState(typeWise[0]);
    const [checked, setChecked] = useState(true);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [fromDate, setFromDate] = useState(tdt);
    const [toDate, setToDate] = useState(new Date());
    const [taxTypeData, setTaxTypeData] = useState([]);
    const [selectedtaxTypeData, setSelectedtaxTypeData] = useState(null);
    const [AllTypeData, setAllTypeData] = useState([]);
    const [selectedalltypeData, setSelectedalltypeData] = useState([]);
    const [InvTypeData, setInvTypeData] = useState([]);
    const [selectedallInvData, setSelectedallInvData] = useState([]);
    const auth = storage.getLocal("user");

    // let doctaxdwl = "SalesReport/TaxDetailRptDocwiseDownload?";
    // let saletaxdwl = "SalesReport/TaxDetailRptSalesTaxDownload?";
    let documenttyp = "SalesReport/TaxDetailRptDoctypeData?";
    let populatetax = "SalesReport/TaxDetailRptPopulateTax?";
    // /api/SalesReport/TaxDetailRptDocwiseDownload
    // /api/SalesReport/TaxDetailRptSalesTaxDownload
    // /api/SalesReport/TaxDetailRptDoctypeData
    // /api/SalesReport/TaxDetailRptPopulateTax
    // console.log(selectedDocno);
    // console.log(selectedtypeWise);
    const pageonLoad = async () => {
        const populatetaxApi = `${populatetax}CompId=${auth.CompId}`;
        const alltypApi = `${documenttyp}CompId=${auth.CompId}&doctype=ALL&fromdate=${format(new Date(fromDate), "dd/MM/yyyy")}&todate=${format(new Date(toDate), "dd/MM/yyyy")}`;
        const invtypApi = `${documenttyp}CompId=${auth.CompId}&doctype=INV&fromdate=${format(new Date(fromDate), "dd/MM/yyyy")}&todate=${format(new Date(toDate), "dd/MM/yyyy")}`;
        try {
            const [taxRes, alltyRes, invtyRes] = await Promise.all([
                Axios.get(populatetaxApi),
                Axios.get(alltypApi),
                Axios.get(invtypApi),
            ]);
            const taxResData = taxRes.data;
            const alltyResData = alltyRes.data;
            const invtyResData = invtyRes.data;
            // console.log(taxRes.data);
            setTaxTypeData(taxResData);
            setAllTypeData(alltyResData);
            setInvTypeData(invtyResData);
            setSelectedallInvData(invtyResData);
            setSelectedalltypeData(alltyResData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    useEffect(() => {
        pageonLoad();
    }, []);
    // console.log(selectedtaxTypeData);
    const handleExportExcel = async () => {
        if (checked) {
            if (selectedtaxTypeData == null || selectedtaxTypeData == undefined) {
                toast.warning("Please select tax type.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            } else {
                setLoadingExcel(true);
                createAPIEndpointSalesReports()
                    .get(
                        `${EndpointSalesReports.TaxDetailRptSalesTaxDownload}?CompId=${
                            auth.CompId
                        }&doctype=${selectedDocno.key}&taxid=${
                            selectedtaxTypeData.TAX_CODE
                        }&fromDate=${format(
                            new Date(fromDate),
                            "dd/MM/yyyy"
                        )}&toDate=${format(new Date(toDate), "dd/MM/yyyy")}`
                    )
                    .then((val) => {
                        if (val.data.length > 0) {
                            downloadExcel(val.data, `Tax_Details${GetDateFormat()}.xlsx`);
                        } else {
                            toast.warning("No data found between these dates", {
                                position: toast.POSITION.TOP_CENTER,
                                pauseOnFocusLoss: false,
                                closeButton: false,
                                autoClose: 2000,
                            });
                        }
                        setLoadingExcel(false);
                    })
                    .catch((err) => {
                        toast.error(`${err.response.data}`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                        setLoadingExcel(false);
                    });
            }
        } else {
            // console.log(selectedallInvData);
            if (
                selectedallInvData.length == null ||
        selectedalltypeData.length == null
            ) {
                toast.warning("Please select document no.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            } else {
                let Invdocnum = selectedallInvData
                    .map((item) => `${item.MASK_INVH_ID}`)
                    .join(",");
                let Alldocnum = selectedalltypeData
                    .map((item) => `${item.MASK_INVH_ID}`)
                    .join(",");
                let savepayload = {
                    compId: auth.CompId,
                    taxorDoctype: selectedtypeWise.key,
                    doctype: selectedDocno.key,
                    invno: selectedDocno.key == "ALL" ? Alldocnum : Invdocnum,
                    fromDate: format(new Date(fromDate), "dd/MM/yyyy"),
                    toDate: format(new Date(toDate), "dd/MM/yyyy"),
                };
                // /api/SalesReport/TaxDetailRptDocwiseDownload
                const reportDownload = "SalesReport/TaxDetailRptDocwiseDownload";
                setLoadingExcel(true);
                const res = await Axios.post(
                    reportDownload,
                    JSON.stringify(savepayload),
                    {
                        headers: { "Content-Type": "application/json" },
                    }
                );

                if (res.data == 0) {
                    toast.warning("No data found between these dates", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                    setLoadingExcel(false);
                } else {
                    downloadExcel(res.data, `Tax_Details${GetDateFormat()}.xlsx`);
                    setLoadingExcel(false);
                }
            }
        }
    };

    const Getdatainv = () => {
        pageonLoad();
    };
    // console.log(selectedallInvData);
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Tax Details Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={loadingExcel}
                                onClick={handleExportExcel}
                            >
                                {loadingExcel ? "Loading..." : "Download Excel"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaDownload className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-5 col-md-6 col-sm-12 mb-3">
                                <label className="form-label mb-2">From Date</label>
                                <Calendar
                                    onChange={(e) => setFromDate(e.value)}
                                    showIcon
                                    value={fromDate}
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-12 mb-3">
                                <label className="form-label mb-2">To Date</label>
                                <Calendar
                                    value={toDate}
                                    onChange={(e) => setToDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-3">
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={Getdatainv}
                                        // disabled={loadingExcel}
                                    >
                    Get Data
                                    </button>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label mb-2">
                  Sales Taxwise Document
                                </label>
                                <InputSwitch
                                    className="switch-pos ms-2"
                                    checked={checked}
                                    onChange={(e) => setChecked(e.value)}
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    {checked ? "Tax Type" : "Document Number"}
                                </label>
                                {checked ? (
                                    <Dropdown
                                        value={selectedtaxTypeData}
                                        onChange={(e) => setSelectedtaxTypeData(e.value)}
                                        options={taxTypeData}
                                        optionLabel="TAX_DESC"
                                        dropdown
                                    />
                                ) : (
                                    <MultiSelect
                                        value={
                                            selectedDocno.key == "ALL"
                                                ? selectedalltypeData
                                                : selectedallInvData
                                        }
                                        onChange={(e) =>
                                            selectedDocno.key == "ALL"
                                                ? setSelectedalltypeData(e.value)
                                                : setSelectedallInvData(e.value)
                                        }
                                        options={
                                            selectedDocno.key == "ALL" ? AllTypeData : InvTypeData
                                        }
                                        optionLabel="INV_NO"
                                        selectAllLabel="All"
                                        dropdown
                                        selectAll={true}
                                    />
                                )}
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                {/* <label className="form-label d-block">Select Type</label> */}
                                {typeWise.map((doc) => {
                                    return (
                                        <div key={doc.key} className="d-inline-flex">
                                            <RadioButton
                                                inputId={doc.key}
                                                name="doc"
                                                value={doc}
                                                onChange={(e) => setSelectedTypeWise(e.value)}
                                                checked={selectedtypeWise.key === doc.key}
                                                disabled={checked}
                                            />
                                            <label htmlFor={doc.key} className="mx-2">
                                                {doc.name}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-3">
                                <div className="flex d-flex flex-wrap gap-2">
                                    {docno.map((doc) => {
                                        return (
                                            <div key={doc.key} className="flex align-items-center">
                                                <RadioButton
                                                    inputId={doc.key}
                                                    name="doc"
                                                    value={doc}
                                                    onChange={(e) => setSelectedDocNo(e.value)}
                                                    checked={selectedDocno.key === doc.key}
                                                />
                                                <label htmlFor={doc.key} className="mx-2">
                                                    {doc.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </>
    );
};

export default TaxDetails;
